


























import Vue from 'vue';
import { ProfileIcon } from 'zenComponents';

export default Vue.extend({
  name: 'PersonPresenter',
  inject: {
    components: {
      default: {
        ProfileIcon,
      },
    },
  },
});
